import chineseCharactersOnlyWhenTaxableSelected
  from '../../../../../form/field-validation/ImportTax/chineseCharactersOnlyWhenTaxableSelected';

export const basic = chineseCharactersOnlyWhenTaxableSelected();
export const fullName = chineseCharactersOnlyWhenTaxableSelected('fullName');
export const address1 = chineseCharactersOnlyWhenTaxableSelected('address1');
export const address2 = chineseCharactersOnlyWhenTaxableSelected('address2');
export const townCity = chineseCharactersOnlyWhenTaxableSelected('town');
export const county = chineseCharactersOnlyWhenTaxableSelected('county');
